<template>
<div>
  <v-overlay v-if="loading" :value="loading">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
  <div v-else>
    <v-row>
      <v-col cols="12" sm="2">
        <MyButtons />
      </v-col>
      <v-col cols="12" sm="3">
        <p class="mytitle primary--text">گزارشات نموداری</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <MyBalances :data="balances" />
      </v-col>
      <v-col cols="12" sm="6">
        <MyBarChart :buys="buys" :sales="sales" />
      </v-col>
      <!-- <v-col cols="12" sm="6">
      </v-col>
      <v-col cols="12" sm="6">
        <MyLineChart :buys="buys" :sales="sales"/>
      </v-col> -->
    </v-row>
  </div>
</div>
</template>

<script>
import myAxios from '../../../functions/myAxios'
import MyBarChart from './components/barChart.vue'
// import MyLineChart from './components/lineChart.vue'
import MyBalances from './components/balances.vue'
import MyButtons from '../Buttons.vue'
export default {
  name: 'MyChart',
  data: () => ({
    loading: true,
    buys: null,
    sales: null,
    balances: null
  }),
  components: {
    MyBarChart,
    // MyLineChart,
    MyBalances,
    MyButtons,
  },
  async mounted() {
    try {
      let res = await myAxios({
        method: 'GET',
        url: `/api/reports/buys`
      });
      if (res && res.data) {
        this.buys = res.data
        // console.log(this.sales);
      }
      //
      res = await myAxios({
        method: 'GET',
        url: `/api/reports/sales`
      });
      if (res && res.data) {
        this.sales = res.data
        // console.log(this.sales);
      }
      //
      res = await myAxios({
        method: 'GET',
        url: `/api/reports/balances/current`,
      });
      if (res && res.data) {
        res.data.map((item, i) => {
          if (i < 6) {
            item.percent = (item.price1 / res.data[8].price1) * 100
          } else if (i == 6) {
            let p = res.data[6].price1 - res.data[7].price1
            item.percent = (p / res.data[8].price1) * 100
          }
        })
        this.balances = res.data
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false
    }
  },
}
</script>

<style lang="css" scoped>
</style>
